import { Modal, Spin } from 'antd';
import { useStore } from 'effector-react';
import { $recalculateInProcess } from '../store/root.store';
import styles from './index.module.sass';

export const RecalculateIndicatorModal = () => {
  const isOpen = useStore($recalculateInProcess);
  return (
    <div style={ !isOpen ? { display: 'none' } : {}} className={styles.rootRecalculteProgress}>
        <div className={styles.innerContent}>
        <span className={styles.tip}>Идет пересчет стоимостей <br/>в системе...</span>
        <Spin spinning={true} tip="Loading..." size='large' />
        </div>
    </div>
  );
};
